export default __webpack_public_path__ + "static/media/subsurfaceUpgrades.dfc34652.svg";